module.exports = __webpack_public_path__ + "media/phiphi/on_phiphi-7033f73b.jpg";